import { useFiltersHooks } from "../../../features/ui"
import { DataType } from "../../../tables"
import { useCashFundLoaders } from "../loaders/cashFundLoaders"
import { useCheckLoaders } from "../loaders/checkLoaders"
import { useCreditCardLoaders } from "../loaders/creditCardLoaders"
import { PaymentOrder, PaymentOrderStatus } from "../state/types"
import { useCheckHooks } from "./checkHooks"
import { useCreditCardHooks } from "./creditCardHooks"

export const usePaymentOrderHooks = () => {
    const cashFundLoaders = useCashFundLoaders()
    const checkLoaders = useCheckLoaders()
    const creditCardLoaders = useCreditCardLoaders()

    const { describeCheck } = useCheckHooks()
    const { describeCreditCard } = useCreditCardHooks()
    const { search } = useFiltersHooks()

    const describeSource = async (sourceId: string): Promise<string> => {
        const { findCashFund } = cashFundLoaders()
        const cashFund = findCashFund(sourceId)
        if (cashFund) {
            return `Caja: ${cashFund.name}`
        }
        const { loadCheck } = checkLoaders()
        const check = await loadCheck(sourceId)
        if (check) {
            return `Cheque: ${describeCheck(check)}`
        }
        const { findCreditCard } = creditCardLoaders()
        const creditCard = findCreditCard(sourceId)
        return describeCreditCard(creditCard!)
    }

    const searchPaymentOrders = (
        paymentOrderList: PaymentOrder[],
        text = '',
        showAll = false
    ): PaymentOrder[] => {
        const valuesFn = (paymentOrderDT: DataType) => {
            const { code } = paymentOrderDT as PaymentOrder
            return [code.toString()]
        }
        const sortFn = (paymentOrderDT_A: DataType, paymentOrderDT_B: DataType) => 
            (paymentOrderDT_B as PaymentOrder).creationDate.localeCompare((paymentOrderDT_A as PaymentOrder).creationDate)

        return search(paymentOrderList, valuesFn, sortFn, text, showAll) as PaymentOrder[]
    }

    return {
        describeSource,
        searchPaymentOrders
    }
}

export const paymentOrderHelpers = {
    isArchivable: (paymentOrder: PaymentOrder): boolean => {
        const { status, archived } = paymentOrder
        return status === PaymentOrderStatus.PAYED && !archived
    }
}
